import { OverlayBadgeDesignTokens } from '@primeng/themes/types/overlaybadge';

export const baseOverlayBadgeToken: OverlayBadgeDesignTokens = {
  root: {
    outline: {
      width: '1px',
    },
  },
};
